// extracted by mini-css-extract-plugin
module.exports = {"HomePage":"HomePage_HomePage__29MH5","DummyContainer":"HomePage_DummyContainer__24AOS","Placeholder":"HomePage_Placeholder__3MFxt"};